/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const CreateCustomRoleDocument = gql`
    mutation createCustomRole($companyId: Int!, $branchId: Int!, $input: RoleInput!) {
  createCustomRole(companyId: $companyId, branchId: $branchId, input: $input) {
    id
  }
}
    `;
export type CreateCustomRoleMutationFn = Apollo.MutationFunction<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>;

/**
 * __useCreateCustomRoleMutation__
 *
 * To run a mutation, you first call `useCreateCustomRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomRoleMutation, { data, loading, error }] = useCreateCustomRoleMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>(CreateCustomRoleDocument, options);
      }
export type CreateCustomRoleMutationHookResult = ReturnType<typeof useCreateCustomRoleMutation>;
export type CreateCustomRoleMutationResult = Apollo.MutationResult<CreateCustomRoleMutation>;
export type CreateCustomRoleMutationOptions = Apollo.BaseMutationOptions<CreateCustomRoleMutation, CreateCustomRoleMutationVariables>;
export const UpdateCustomRoleDocument = gql`
    mutation updateCustomRole($companyId: Int!, $branchId: Int!, $roleId: Int!, $input: RoleInput!) {
  updateCustomRole(
    companyId: $companyId
    branchId: $branchId
    roleId: $roleId
    input: $input
  ) {
    id
  }
}
    `;
export type UpdateCustomRoleMutationFn = Apollo.MutationFunction<UpdateCustomRoleMutation, UpdateCustomRoleMutationVariables>;

/**
 * __useUpdateCustomRoleMutation__
 *
 * To run a mutation, you first call `useUpdateCustomRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomRoleMutation, { data, loading, error }] = useUpdateCustomRoleMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      roleId: // value for 'roleId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomRoleMutation, UpdateCustomRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomRoleMutation, UpdateCustomRoleMutationVariables>(UpdateCustomRoleDocument, options);
      }
export type UpdateCustomRoleMutationHookResult = ReturnType<typeof useUpdateCustomRoleMutation>;
export type UpdateCustomRoleMutationResult = Apollo.MutationResult<UpdateCustomRoleMutation>;
export type UpdateCustomRoleMutationOptions = Apollo.BaseMutationOptions<UpdateCustomRoleMutation, UpdateCustomRoleMutationVariables>;
export type CreateCustomRoleMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  input: Types.RoleInput;
}>;


export type CreateCustomRoleMutation = { __typename?: 'Mutation', createCustomRole: { __typename?: 'RoleProxy', id: number } };

export type UpdateCustomRoleMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  roleId: Types.Scalars['Int']['input'];
  input: Types.RoleInput;
}>;


export type UpdateCustomRoleMutation = { __typename?: 'Mutation', updateCustomRole: { __typename?: 'RoleProxy', id: number } };
